import React, { createContext, useState, useContext, useMemo } from 'react';
import PropTypes from "prop-types";

const FormContext = createContext();

export function FormProvider({ children }) {
  const [blurredValues, setBlurredValues] = useState({});

  const updateBlurredValue = (name, value) => {
    setBlurredValues((prev) => ({ ...prev, [name]: value }));
  };

  const contextValue = useMemo(() => ({ blurredValues, updateBlurredValue }), [blurredValues]);

  return (
    <FormContext.Provider value={contextValue}>
      {children}
    </FormContext.Provider>
  );
}

FormProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useFormContext() {
  return useContext(FormContext);
}
